// Auto-generated by bake-progress-data.js — do not edit manually
// Last baked: 2026-03-30T14:59:47.574Z

export const reportDate = 'April 9, 2026';
export const goLiveDate = 'April 14, 2026';
export const totalProperties = 93;

export const execSummary = {
  "actionRequired": "Client staging feedback received — template fixes in progress, content items queued. Repli Engineering and SEO teams coordinating with Case on tracking, analytics, and integrations before go-live.",
  "highlights": [
    "17 page types built and deployed across all 92 properties",
    "5 of 18 customer action items completed",
    "2,427 content and configuration overrides applied (1,806 content tokens, 617 slot groups, 4 section overrides)",
    "Lead routing end-to-end tested — full sweep across all 93 properties complete",
    "Floorplan PDFs scraped, uploaded to CDN, and linked on all property pages",
    "297 custom field values migrated to database (ResidentBoost, Rentgrata, GA4, floorplan URLs, PPC numbers)",
    "93 ad landing pages live — ads launching April 1 as scheduled",
    "Image ordering and placement completed across all properties",
    "CallRail and GTM audits completed — current configs need restructuring (coordinating with Case)",
    "All URL redirects configured for seamless transition from old site",
    "Content schemas generated for all page types",
    "Search and map UX/UI reworked with improved filtering and interaction",
    "Contact form redesigned; office hours converted to AM/PM; filtered galleries deployed"
  ],
  "blockers": [],
  "needsAttention": [],
  "propertyGaps": [
    {
      "name": "Bluffs at Catoosa",
      "issue": "Confirmed as new construction — excluded from launch"
    },
  ]
} as const;

export const properties = [
  {
    "name": "152 Northland",
    "slug": "152-northland",
    "stateSlug": "mo",
    "citySlug": "kansas-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/mo/kansas-city/152-northland/",
    "newPath": "/apartments/mo/kansas-city/152-northland",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "24Hundred Apartments",
    "slug": "24-hundred",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/24-hundred/",
    "newPath": "/apartments/ok/oklahoma-city/24-hundred",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "97 at North Oak",
    "slug": "97-north-oak",
    "stateSlug": "mo",
    "citySlug": "kansas-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/",
    "newPath": "/apartments/mo/kansas-city/97-north-oak",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Acacia Park Apts.",
    "slug": "acacia-park",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/acacia-park/",
    "newPath": "/apartments/tx/el-paso/acacia-park",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Apple Creek Stillwater",
    "slug": "apple-creek",
    "stateSlug": "ok",
    "citySlug": "stillwater",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/stillwater/apple-creek/",
    "newPath": "/apartments/ok/stillwater/apple-creek",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Arbors of Pleasant Valley Apts",
    "slug": "arbors-of-pleasant-valley",
    "stateSlug": "ar",
    "citySlug": "little-rock",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ar/little-rock/arbors-of-pleasant-valley/",
    "newPath": "/apartments/ar/little-rock/arbors-of-pleasant-valley",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Artisan Crossing Apts",
    "slug": "artisan-crossing",
    "stateSlug": "ok",
    "citySlug": "norman",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/norman/artisan-crossing/",
    "newPath": "/apartments/ok/norman/artisan-crossing",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Aspen Park",
    "slug": "aspen-park",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/aspen-park/",
    "newPath": "/apartments/ks/wichita/aspen-park",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Barrington Apartments",
    "slug": "barrington",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/barrington/",
    "newPath": "/apartments/ok/tulsa/barrington",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Bend at New Road",
    "slug": "bend-at-new-road",
    "stateSlug": "tx",
    "citySlug": "waco",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/waco/bend-at-new-road/",
    "newPath": "/apartments/tx/waco/bend-at-new-road",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cascata Luxury Apartments",
    "slug": "cascata",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/cascata/",
    "newPath": "/apartments/ok/tulsa/cascata",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cedar Glade Apts",
    "slug": "cedar-glade",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/cedar-glade/",
    "newPath": "/apartments/ok/tulsa/cedar-glade",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cedar Ridge Apartments",
    "slug": "cedar-ridge",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/cedar-ridge/",
    "newPath": "/apartments/ok/tulsa/cedar-ridge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Center 301",
    "slug": "center-301",
    "stateSlug": "mo",
    "citySlug": "belton",
    "oldSiteUrl": "https://www.caseusa.com/apartments/mo/belton/center-301/",
    "newPath": "/apartments/mo/belton/center-301",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Chardonnay",
    "slug": "chardonnay",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/chardonnay/",
    "newPath": "/apartments/ok/tulsa/chardonnay",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Chimneys Apts.",
    "slug": "the-chimneys",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/the-chimneys/",
    "newPath": "/apartments/tx/el-paso/the-chimneys",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Chisholm Pointe",
    "slug": "chisholm-pointe",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/chisholm-pointe/",
    "newPath": "/apartments/ok/oklahoma-city/chisholm-pointe",
    "integrations": {
      "GA4": false,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cimarron Pointe Apts.",
    "slug": "cimarron-pointe",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/cimarron-pointe/",
    "newPath": "/apartments/ok/oklahoma-city/cimarron-pointe",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cimarron Trails Apts.",
    "slug": "cimarron-trails",
    "stateSlug": "ok",
    "citySlug": "norman",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/norman/cimarron-trails/",
    "newPath": "/apartments/ok/norman/cimarron-trails",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Coffee Creek",
    "slug": "coffee-creek",
    "stateSlug": "ok",
    "citySlug": "owasso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/owasso/coffee-creek/",
    "newPath": "/apartments/ok/owasso/coffee-creek",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cottages at Abbey Glen",
    "slug": "cottages-at-abbey-glen",
    "stateSlug": "tx",
    "citySlug": "lubbock",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/lubbock/cottages-at-abbey-glen/",
    "newPath": "/apartments/tx/lubbock/cottages-at-abbey-glen",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cottages at Crestview",
    "slug": "cottages-at-crestview",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/cottages-at-crestview/",
    "newPath": "/apartments/ks/wichita/cottages-at-crestview",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cottages at Tallgrass Point",
    "slug": "cottages-at-tallgrass-point",
    "stateSlug": "ok",
    "citySlug": "owasso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/owasso/cottages-at-tallgrass-point/",
    "newPath": "/apartments/ok/owasso/cottages-at-tallgrass-point",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Council Place Apartments",
    "slug": "council-place",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/council-place/",
    "newPath": "/apartments/ok/oklahoma-city/council-place",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Country Hollow Apartments",
    "slug": "country-hollow",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/country-hollow/",
    "newPath": "/apartments/ok/tulsa/country-hollow",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Creekwood Apartments",
    "slug": "creekwood",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/creekwood/",
    "newPath": "/apartments/ok/tulsa/creekwood",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cross Timber",
    "slug": "cross-timber",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/cross-timber/",
    "newPath": "/apartments/ok/oklahoma-city/cross-timber",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Crown Chase Apts",
    "slug": "crown-chase",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/crown-chase/",
    "newPath": "/apartments/ks/wichita/crown-chase",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Crown Pointe Apartments",
    "slug": "crown-pointe",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/crown-pointe/",
    "newPath": "/apartments/ok/oklahoma-city/crown-pointe",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Cypress Crossing",
    "slug": "cypress-crossing",
    "stateSlug": "ok",
    "citySlug": "owasso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/owasso/cypress-crossing/",
    "newPath": "/apartments/ok/owasso/cypress-crossing",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Double Tree Apts.",
    "slug": "double-tree",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/double-tree/",
    "newPath": "/apartments/tx/el-paso/double-tree",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Fountain Lake",
    "slug": "fountain-lake",
    "stateSlug": "ok",
    "citySlug": "edmond",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/edmond/fountain-lake/",
    "newPath": "/apartments/ok/edmond/fountain-lake",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "High Ridge Apts.",
    "slug": "high-ridge",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/high-ridge/",
    "newPath": "/apartments/tx/el-paso/high-ridge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Hunter's Ridge Apts.",
    "slug": "hunters-ridge",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/hunters-ridge/",
    "newPath": "/apartments/ok/oklahoma-city/hunters-ridge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Huntington Park",
    "slug": "huntington-park",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/huntington-park/",
    "newPath": "/apartments/ks/wichita/huntington-park",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Icon at Broken Arrow Apartments",
    "slug": "icon-at-broken-arrow",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/icon-at-broken-arrow/",
    "newPath": "/apartments/ok/broken-arrow/icon-at-broken-arrow",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Icon at Hewitt",
    "slug": "icon-at-hewitt",
    "stateSlug": "tx",
    "citySlug": "hewitt",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/hewitt/icon-at-hewitt/",
    "newPath": "/apartments/tx/hewitt/icon-at-hewitt",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Icon at Lubbock",
    "slug": "icon-at-lubbock",
    "stateSlug": "tx",
    "citySlug": "lubbock",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/lubbock/icon-at-lubbock/",
    "newPath": "/apartments/tx/lubbock/icon-at-lubbock",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Lexington Park",
    "slug": "lexington-park",
    "stateSlug": "ar",
    "citySlug": "north-little-rock",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ar/north-little-rock/lexington-park/",
    "newPath": "/apartments/ar/north-little-rock/lexington-park",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Mark Apts.",
    "slug": "the-mark",
    "stateSlug": "ms",
    "citySlug": "ridgeland",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ms/ridgeland/the-mark/",
    "newPath": "/apartments/ms/ridgeland/the-mark",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Mission Point",
    "slug": "mission-point",
    "stateSlug": "ok",
    "citySlug": "moore",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/moore/mission-point/",
    "newPath": "/apartments/ok/moore/mission-point",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Mountain Village Apts.",
    "slug": "mountain-village",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/mountain-village/",
    "newPath": "/apartments/tx/el-paso/mountain-village",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Newport Amarillo Apts",
    "slug": "newport",
    "stateSlug": "tx",
    "citySlug": "amarillo",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/amarillo/newport/",
    "newPath": "/apartments/tx/amarillo/newport",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Newport Wichita Apts.",
    "slug": "newport-wichita",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/newport-wichita/",
    "newPath": "/apartments/ks/wichita/newport-wichita",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Nickel Creek Apts",
    "slug": "nickel-creek",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/nickel-creek/",
    "newPath": "/apartments/ok/tulsa/nickel-creek",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Park at Coulter",
    "slug": "park-at-coulter",
    "stateSlug": "tx",
    "citySlug": "amarillo",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/amarillo/park-at-coulter/",
    "newPath": "/apartments/tx/amarillo/park-at-coulter",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Park at Mission Hills",
    "slug": "park-at-mission-hills",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/park-at-mission-hills/",
    "newPath": "/apartments/ok/broken-arrow/park-at-mission-hills",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Park at Tuscany",
    "slug": "park-at-tuscany",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/park-at-tuscany/",
    "newPath": "/apartments/ok/oklahoma-city/park-at-tuscany",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Park at Westpointe",
    "slug": "park-at-westpointe",
    "stateSlug": "ok",
    "citySlug": "yukon",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/yukon/park-at-westpointe/",
    "newPath": "/apartments/ok/yukon/park-at-westpointe",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Patriot Apts.",
    "slug": "the-patriot",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/the-patriot/",
    "newPath": "/apartments/tx/el-paso/the-patriot",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Persimmon Square Apartments",
    "slug": "persimmon-square",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/persimmon-square/",
    "newPath": "/apartments/ok/oklahoma-city/persimmon-square",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Phoenix Apts",
    "slug": "the-phoenix",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/the-phoenix/",
    "newPath": "/apartments/tx/el-paso/the-phoenix",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Polo Run Apartments",
    "slug": "polo-run",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/polo-run/",
    "newPath": "/apartments/ok/tulsa/polo-run",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Portico at Friars Creek Apts",
    "slug": "portico-at-friars-creek",
    "stateSlug": "tx",
    "citySlug": "temple",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/temple/portico-at-friars-creek/",
    "newPath": "/apartments/tx/temple/portico-at-friars-creek",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Portofino",
    "slug": "portofino",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/portofino/",
    "newPath": "/apartments/ks/wichita/portofino",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Prairie Springs I",
    "slug": "prairie-springs",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/prairie-springs/",
    "newPath": "/apartments/ok/oklahoma-city/prairie-springs",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Raintree Apts",
    "slug": "raintree",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/raintree/",
    "newPath": "/apartments/ks/wichita/raintree",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Redbud Ranch",
    "slug": "redbud-ranch",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/redbud-ranch/",
    "newPath": "/apartments/ok/broken-arrow/redbud-ranch",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Remington Amarillo Apts",
    "slug": "remington",
    "stateSlug": "tx",
    "citySlug": "amarillo",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/amarillo/remington/",
    "newPath": "/apartments/tx/amarillo/remington",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Remington Wichita",
    "slug": "the-remington",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/the-remington/",
    "newPath": "/apartments/ks/wichita/the-remington",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Scissortail Crossing",
    "slug": "scissortail-crossing",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/scissortail-crossing/",
    "newPath": "/apartments/ok/broken-arrow/scissortail-crossing",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Shadow Ridge Apts.",
    "slug": "shadow-ridge",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/shadow-ridge/",
    "newPath": "/apartments/tx/el-paso/shadow-ridge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Sheridan Pond",
    "slug": "sheridan-pond",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/sheridan-pond/",
    "newPath": "/apartments/ok/tulsa/sheridan-pond",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Silver Springs",
    "slug": "silver-springs",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/silver-springs/",
    "newPath": "/apartments/ks/wichita/silver-springs",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Stonehorse Crossing",
    "slug": "stonehorse-crossing",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/stonehorse-crossing/",
    "newPath": "/apartments/ok/oklahoma-city/stonehorse-crossing",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Sugarberry Apartments",
    "slug": "sugarberry",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/sugarberry/",
    "newPath": "/apartments/ok/tulsa/sugarberry",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Summerfield Place Apts.",
    "slug": "summerfield-place",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/summerfield-place/",
    "newPath": "/apartments/ok/oklahoma-city/summerfield-place",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": false,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Summit Ridge Villas",
    "slug": "summit-villas",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/chisholm-pointe/summit-villas/",
    "newPath": "/apartments/ok/oklahoma-city/summit-villas",
    "integrations": {
      "GA4": false,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Sunchase Apartments",
    "slug": "sunchase",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/sunchase/",
    "newPath": "/apartments/ok/tulsa/sunchase",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Sunchase Ridgeland Apts.",
    "slug": "sunchase-ridgeland",
    "stateSlug": "ms",
    "citySlug": "ridgeland",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ms/ridgeland/sunchase-ridgeland/",
    "newPath": "/apartments/ms/ridgeland/sunchase-ridgeland",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Tammaron Village Apartments",
    "slug": "tammaron-village",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/tammaron-village/",
    "newPath": "/apartments/ok/oklahoma-city/tammaron-village",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Adirondack",
    "slug": "adirondack",
    "stateSlug": "mo",
    "citySlug": "independence",
    "oldSiteUrl": "https://www.caseusa.com/apartments/mo/independence/adirondack/",
    "newPath": "/apartments/mo/independence/adirondack",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Colonies at Hillside",
    "slug": "colonies-at-hillside",
    "stateSlug": "tx",
    "citySlug": "amarillo",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/amarillo/colonies-at-hillside/",
    "newPath": "/apartments/tx/amarillo/colonies-at-hillside",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Courtyards",
    "slug": "the-courtyards",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/the-courtyards/",
    "newPath": "/apartments/ok/tulsa/the-courtyards",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Crest",
    "slug": "the-crest",
    "stateSlug": "tx",
    "citySlug": "el-paso",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/el-paso/the-crest/",
    "newPath": "/apartments/tx/el-paso/the-crest",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Greens Of Bedford",
    "slug": "greens-of-bedford",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/greens-of-bedford/",
    "newPath": "/apartments/ok/tulsa/greens-of-bedford",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Pointe Of Ridgeland",
    "slug": "pointe-of-ridgeland",
    "stateSlug": "ms",
    "citySlug": "ridgeland",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ms/ridgeland/pointe-of-ridgeland/",
    "newPath": "/apartments/ms/ridgeland/pointe-of-ridgeland",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Reserve at Elm",
    "slug": "reserve-at-elm",
    "stateSlug": "ok",
    "citySlug": "jenks",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/jenks/reserve-at-elm/",
    "newPath": "/apartments/ok/jenks/reserve-at-elm",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "The Ridge @ 66",
    "slug": "ridge-at-66",
    "stateSlug": "ok",
    "citySlug": "yukon",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/yukon/ridge-at-66/",
    "newPath": "/apartments/ok/yukon/ridge-at-66",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Trace Apts.",
    "slug": "trace-of-ridgeland",
    "stateSlug": "ms",
    "citySlug": "ridgeland",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ms/ridgeland/trace-of-ridgeland/",
    "newPath": "/apartments/ms/ridgeland/trace-of-ridgeland",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Trails at Aspen Creek",
    "slug": "trails-at-aspen-creek",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/trails-at-aspen-creek/",
    "newPath": "/apartments/ok/broken-arrow/trails-at-aspen-creek",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Tuscany Place",
    "slug": "tuscany-place",
    "stateSlug": "tx",
    "citySlug": "lubbock",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/lubbock/tuscany-place/",
    "newPath": "/apartments/tx/lubbock/tuscany-place",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Tuscany Ranch Apartments",
    "slug": "tuscany-ranch",
    "stateSlug": "tx",
    "citySlug": "waco",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/waco/tuscany-ranch/",
    "newPath": "/apartments/tx/waco/tuscany-ranch",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Villas at Aspen Park",
    "slug": "villas-at-aspen-park",
    "stateSlug": "ok",
    "citySlug": "broken-arrow",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/broken-arrow/villas-at-aspen-park/",
    "newPath": "/apartments/ok/broken-arrow/villas-at-aspen-park",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Villas at Stonebridge",
    "slug": "villas-at-stonebridge",
    "stateSlug": "ok",
    "citySlug": "edmond",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/edmond/villas-at-stonebridge/",
    "newPath": "/apartments/ok/edmond/villas-at-stonebridge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Villas of Waterford",
    "slug": "villas-of-waterford",
    "stateSlug": "ks",
    "citySlug": "wichita",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/wichita/villas-of-waterford/",
    "newPath": "/apartments/ks/wichita/villas-of-waterford",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Warrington Apartments",
    "slug": "warrington",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/warrington/",
    "newPath": "/apartments/ok/oklahoma-city/warrington",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Watercress",
    "slug": "watercress",
    "stateSlug": "ks",
    "citySlug": "maize",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ks/maize/watercress/",
    "newPath": "/apartments/ks/maize/watercress",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Waters Edge Apartments",
    "slug": "waters-edge",
    "stateSlug": "ok",
    "citySlug": "oklahoma-city",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/oklahoma-city/waters-edge/",
    "newPath": "/apartments/ok/oklahoma-city/waters-edge",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": true,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "West 530",
    "slug": "west-530",
    "stateSlug": "ok",
    "citySlug": "pryor",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/pryor/west-530/",
    "newPath": "/apartments/ok/pryor/west-530",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": false,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": false,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Winchester Apartments",
    "slug": "winchester",
    "stateSlug": "tx",
    "citySlug": "amarillo",
    "oldSiteUrl": "https://www.caseusa.com/apartments/tx/amarillo/winchester/",
    "newPath": "/apartments/tx/amarillo/winchester",
    "integrations": {
      "GA4": true,
      "ResidentBoost": false,
      "Rentgrata": true,
      "Zuma": false
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  },
  {
    "name": "Windsail Apts.",
    "slug": "windsail",
    "stateSlug": "ok",
    "citySlug": "tulsa",
    "oldSiteUrl": "https://www.caseusa.com/apartments/ok/tulsa/windsail/",
    "newPath": "/apartments/ok/tulsa/windsail",
    "integrations": {
      "GA4": true,
      "ResidentBoost": true,
      "Rentgrata": false,
      "Zuma": true
    },
    "assets": {
      "virtual_tour_url": true,
      "tour24_url": true,
      "floorplan_pdf_url": true
    }
  }
] as const;

export const integrationStats = [
  {
    "key": "GA4",
    "label": "GA4 Analytics",
    "count": 90,
    "total": 92
  },
  {
    "key": "ResidentBoost",
    "label": "ResidentBoost Chat",
    "count": 55,
    "total": 92
  },
  {
    "key": "Rentgrata",
    "label": "Rentgrata",
    "count": 58,
    "total": 92
  },
  {
    "key": "Zuma",
    "label": "Zuma Chat",
    "count": 54,
    "total": 92
  }
] as const;

export const assetStats = [
  {
    "key": "virtual_tour_url",
    "label": "Virtual Tour",
    "count": 80,
    "total": 92
  },
  {
    "key": "tour24_url",
    "label": "Self-Guided Tour",
    "count": 86,
    "total": 92
  },
  {
    "key": "floorplan_pdf_url",
    "label": "Floor Plan / Site Map",
    "count": 92,
    "total": 92
  }
] as const;

export const siteWideIntegrations = [
  {
    "label": "Google Tag Manager",
    "status": "in-progress",
    "note": "Current GTM config is messy. Recommend starting fresh — needs strategy discussion with Case and SEO team."
  },
  {
    "label": "CallRail (Call Tracking)",
    "status": "blocked",
    "note": "Current configuration found to be broken. Needs coordination with Case to restructure."
  },
  {
    "label": "Microsoft Clarity",
    "status": "pending",
    "note": "Seeking customer feedback"
  },
  {
    "label": "Facebook Pixel",
    "status": "pending"
  },
  {
    "label": "Flex Payment",
    "status": "pending"
  },
  {
    "label": "Google Ads Conversions",
    "status": "pending"
  }
] as const;

export const pagesBuilt = [
  {
    "name": "Corporate Home",
    "path": "/"
  },
  {
    "name": "About Us",
    "path": "/about-us"
  },
  {
    "name": "All Apartments (Search)",
    "path": "/apartments"
  },
  {
    "name": "Careers",
    "path": "/careers",
    "note": "Shell — pending Taleo integration"
  },
  {
    "name": "Awards",
    "path": "/awards"
  },
  {
    "name": "Contact Us",
    "path": "/contact-us"
  },
  {
    "name": "Privacy Policy",
    "path": "/privacy-policy"
  },
  {
    "name": "Accessibility Statement",
    "path": "/accessibility-statement"
  },
  {
    "name": "State Listing Pages",
    "path": "/apartments/{state}"
  },
  {
    "name": "City Listing Pages",
    "path": "/apartments/{state}/{city}"
  },
  {
    "name": "Property Home",
    "path": ".../{property}"
  },
  {
    "name": "Property Floor Plans",
    "path": ".../{property}/floor-plans"
  },
  {
    "name": "Property Amenities",
    "path": ".../{property}/amenities"
  },
  {
    "name": "Property Neighborhood",
    "path": ".../{property}/neighborhood"
  },
  {
    "name": "Property Gallery",
    "path": ".../{property}/photos"
  },
  {
    "name": "Property Pet Policy",
    "path": ".../{property}/pet-policy"
  },
  {
    "name": "Property Contact",
    "path": ".../{property}/contact-us"
  }
] as const;

export const customerActions = [
  {
    "item": "Reconcile full property list (97 contracted vs 92 active)",
    "owner": "Lacy / Britt",
    "priority": "high",
    "status": "not-started"
  },
  {
    "item": "Corporate brand guide",
    "owner": "Jordan",
    "priority": "high",
    "status": "done"
  },
  {
    "item": "Individual property brand guides",
    "owner": "Jordan",
    "priority": "high",
    "status": "done"
  },
  {
    "item": "Google Ads manager access",
    "owner": "Britt",
    "priority": "high",
    "status": "done"
  },
  {
    "item": "GoLocal contract end date",
    "owner": "Lacy / Britt",
    "priority": "high",
    "status": "done"
  },
  {
    "item": "SOCI contract end date",
    "owner": "Lacy / Britt",
    "priority": "high",
    "status": "done"
  },
  {
    "item": "Review and approve design / styling changes",
    "owner": "Jordan / Britt",
    "priority": "high",
    "status": "not-started"
  },
  {
    "item": "End-to-end lead routing test (Yardi) — coordinate when ready",
    "owner": "Britt",
    "priority": "high",
    "status": "not-started"
  },
  {
    "item": "Confirm mobile behavior for ResidentBoost and Rentgrata widgets (hide on mobile or show?)",
    "owner": "Britt",
    "priority": "high",
    "status": "not-started"
  },
  {
    "item": "Help curate property image ordering (if available)",
    "owner": "Jordan / Case Team",
    "priority": "high",
    "status": "not-started"
  },
  {
    "item": "CallRail tracking number export (if available — we can copy from existing site if not)",
    "owner": "Case Team",
    "priority": "medium",
    "status": "not-started"
  },
  {
    "item": "List of properties using Landing (furnished units)",
    "owner": "Case Team",
    "priority": "medium",
    "status": "not-started"
  },
  {
    "item": "List of non-luxury properties (for design tier)",
    "owner": "Case Team",
    "priority": "medium",
    "status": "not-started"
  },
  {
    "item": "Google Tag Manager access verification",
    "owner": "Crystal",
    "priority": "medium",
    "status": "pending"
  },
  {
    "item": "Facebook Business Manager partner access",
    "owner": "Case Team",
    "priority": "medium",
    "status": "pending"
  },
  {
    "item": "Ad spend budgets per property",
    "owner": "Britt",
    "priority": "medium",
    "status": "not-started"
  },
  {
    "item": "Year-end SEO report / keyword rankings",
    "owner": "Case Team",
    "priority": "medium",
    "status": "pending"
  },
  {
    "item": "Taleo API details (careers page)",
    "owner": "Case Team",
    "priority": "low",
    "status": "pending"
  }
] as const;

export const timeline = [
  {
    "week": "Mar 10–21",
    "label": "Complete",
    "desc": "Integration blocks; data migration; content migration; performance optimization"
  },
  {
    "week": "Mar 24–28",
    "label": "Complete",
    "desc": "Final QA; ads team review; remaining content and UX items"
  },
  {
    "week": "Mar 31–Apr 4",
    "label": "Complete",
    "desc": "Ads launch (Apr 1 as scheduled); website launch prep continues; QA finalization"
  },
  {
    "week": "Apr 6–10",
    "label": "Current",
    "desc": "Client action items; Website DNS cutover; analytics activation; monitoring"
  }
] as const;

export const outstanding = [
  {
    "title": "Website Launch Delayed Two Weeks",
    "desc": "Due to a cyber attack on Case & Associates, the website launch has been pushed from April 1 to April 14. Ads launch remains on schedule for April 1.",
    "warning": true,
    "tasks": [
      {
        "label": "Ads launch proceeding on April 1 as scheduled",
        "done": true
      },
      {
        "label": "Website go-live moved to April 14",
        "done": true
      },
      {
        "label": "DNS cutover coordination with Case IT",
        "done": false,
        "note": "Scheduled for Monday, Apr 13."
      }
    ]
  },
  {
    "title": "Launch Coordination",
    "desc": "Final coordination items before cutover: tracking plan handoff, Tour24 URL confirmation, and cutover / DNI scheduling.",
    "warning": true,
    "tasks": [
      {
        "label": "Create and send over tracking configuration plan",
        "done": false,
        "status": "in-progress"
      },
      {
        "label": "Tour24 URLs: finalize or confirm missing properties",
        "done": false,
        "status": "pending",
        "note": "Review remaining Tour24 fields in Multihub.",
        "href": "https://console.multihub.io/company/company-properties?aid=5680529164730368&cid=5767906449162419&v=custom_tour24_url",
        "linkText": "Open Tour24 property list"
      },
      {
        "label": "Cutover / DNI scheduled for Monday, April 13",
        "done": false,
        "status": "pending"
      }
    ]
  },
  {
    "title": "Content Migration",
    "desc": "Migrating property descriptions, headers, and FAQ content from the current sites.",
    "tasks": [
      {
        "label": "Text content (~1,600 blurbs across 93 properties)",
        "done": true
      },
      {
        "label": "Corporate interior page content and assets",
        "done": true
      },
      {
        "label": "Internal link matching",
        "done": true
      },
      {
        "label": "FAQs migrated",
        "done": true
      },
      {
        "label": "Page headers and hero content — deferred to post-launch SEO review",
        "done": true,
        "note": "Will revisit with SEO team"
      }
    ]
  },
  {
    "title": "Lead Routing (Yardi)",
    "desc": "Yardi lead routers and Multihub lead capture configured for all 93 properties.",
    "tasks": [
      {
        "label": "Multihub lead capture spun up for all 93 properties",
        "done": true
      },
      {
        "label": "Event tracking flowing to our system",
        "done": true
      },
      {
        "label": "Yardi lead routers configured",
        "done": true
      },
      {
        "label": "End-to-end test confirmed (24Hundred + Apple Creek Stillwater)",
        "done": true
      },
      {
        "label": "Full sweep across all 93 properties",
        "done": true
      }
    ]
  },
  {
    "title": "Image Ordering & Mapping",
    "desc": "Mapping images to the correct positions on each page at scale.",
    "tasks": [
      {
        "label": "Property images ingested from current site",
        "done": true
      },
      {
        "label": "Image placement logic built",
        "done": true
      },
      {
        "label": "Image ordering tuned per property",
        "done": true
      }
    ]
  },
  {
    "title": "Tour Scheduler Modal",
    "desc": "Building the \"In-Person / Self-Guided / Live Video Call\" tour scheduling experience.",
    "tasks": [
      {
        "label": "Tour24 URLs collected for all applicable properties",
        "done": true
      },
      {
        "label": "External tour URLs collected",
        "done": true
      },
      {
        "label": "Schedule-a-tour linking fixed",
        "done": true
      },
      {
        "label": "Modal UI with format selection",
        "done": true,
      },
      {
        "label": "Connect modal to Tour24 / scheduling endpoints",
        "done": true
      }
    ]
  },
  {
    "title": "Floorplan PDFs",
    "desc": "Each property's \"View Our Floorplans\" PDF scraped, uploaded, and linked.",
    "tasks": [
      {
        "label": "PDFs scraped from current site (92 properties)",
        "done": true
      },
      {
        "label": "Uploaded to CDN for delivery",
        "done": true
      },
      {
        "label": "Linked on site",
        "done": true
      }
    ]
  },
  {
    "title": "Call Tracking (CallRail)",
    "desc": "Dynamic number insertion for call attribution.",
    "warning": true,
    "tasks": [
      {
        "label": "CallRail integration built",
        "done": true
      },
      {
        "label": "Account and tracking config extracted",
        "done": true
      },
      {
        "label": "PPC tracking phone numbers migrated (92 properties)",
        "done": true
      },
      {
        "label": "Audit of current CallRail configuration completed",
        "done": true
      },
      {
        "label": "Current configuration found to be broken — needs restructuring",
        "done": true,
        "note": "Existing setup has issues"
      },
      {
        "label": "Coordinate with Case team on correct tracking structure",
        "done": false,
        "note": "Needs discussion"
      }
    ]
  },
  {
    "title": "ResidentBoost Widget",
    "desc": "AI leasing chatbot — installed with known mobile limitations.",
    "warning": true,
    "tasks": [
      {
        "label": "Widget integration built",
        "done": true
      },
      {
        "label": "Per-property IDs migrated (55 properties)",
        "done": true
      },
      {
        "label": "Desktop rendering verified",
        "done": true
      },
      {
        "label": "Mobile behavior: currently hidden on existing site due to rendering issues",
        "done": true,
        "note": "Matching current site behavior"
      }
    ]
  },
  {
    "title": "Rentgrata Widget",
    "desc": "Resident referral chat widget — installed with known mobile limitations.",
    "warning": true,
    "tasks": [
      {
        "label": "Widget integration built",
        "done": true
      },
      {
        "label": "Per-property IDs migrated (58 properties)",
        "done": true
      },
      {
        "label": "Desktop rendering verified",
        "done": true
      },
      {
        "label": "Mobile behavior: currently hidden on existing site due to wrapping issues",
        "done": true,
        "note": "Matching current site behavior"
      }
    ]
  },
  {
    "title": "Hyly Attribution",
    "desc": "Marketing attribution tracking — installed with known vendor issues.",
    "warning": true,
    "tasks": [
      {
        "label": "Integration built",
        "done": true
      },
      {
        "label": "SSID extracted and configured",
        "done": true
      },
      {
        "label": "Vendor code quality issues identified and reported",
        "done": true
      },
      {
        "label": "Vendor fix deployed and verified",
        "done": true,
        "status": "cancelled",
        "note": "Hyly removed from scope; we are no longer using this vendor."
      }
    ]
  },
  {
    "title": "Vibesites Editor (CMS)",
    "desc": "Content management interface for the Case team.",
    "tasks": [
      {
        "label": "Single-domain architecture adapted for Vibesites platform",
        "done": true
      },
      {
        "label": "Live site fully functional",
        "done": true
      },
      {
        "label": "Dynamic preview sizing and transitions",
        "done": true
      },
      {
        "label": "Inline slot group editor with cancel support",
        "done": true
      },
      {
        "label": "Internal link navigation in edit mode",
        "done": true
      },
      {
        "label": "Theme-level design token overrides",
        "done": true
      },
      {
        "label": "Deployment logging and user messages",
        "done": true
      }
    ]
  },
  {
    "title": "Ads & Landing Pages",
    "desc": "Landing pages and ad campaigns — launching April 1 as originally scheduled.",
    "tasks": [
      {
        "label": "93 landing pages spun up",
        "done": true
      },
      {
        "label": "Landing page theme refined",
        "done": true
      },
      {
        "label": "Landing page lead routing tested",
        "done": true
      },
      {
        "label": "Ads team trained internally",
        "done": true
      },
      {
        "label": "Ads team final review",
        "done": true
      },
      {
        "label": "DNS cutover for ads landing pages tested and ready",
        "done": true
      },
      {
        "label": "Ads launch April 1",
        "done": true,
      }
    ]
  },
  {
    "title": "GA4 Analytics",
    "desc": "Per-property Google Analytics tracking.",
    "tasks": [
      {
        "label": "Per-property measurement IDs extracted (90 of 92)",
        "done": true
      },
      {
        "label": "Integration block built and tested",
        "done": true
      },
      {
        "label": "Activate on DNS cutover (holding to avoid preview data)",
        "done": false
      }
    ]
  },
  {
    "title": "Custom Field Migration",
    "desc": "Migrating per-property integration IDs and asset URLs to the database.",
    "tasks": [
      {
        "label": "ResidentBoost IDs migrated (55 properties)",
        "done": true
      },
      {
        "label": "Rentgrata IDs migrated (58 properties)",
        "done": true
      },
      {
        "label": "GA4 IDs migrated (90 properties)",
        "done": true
      },
      {
        "label": "Floorplan PDF URLs migrated (92 properties)",
        "done": true
      },
      {
        "label": "PPC tracking phone numbers migrated (92 properties)",
        "done": true
      }
    ]
  },
  {
    "title": "Special Offers",
    "desc": "Property-level promotional offers and move-in specials.",
    "tasks": [
      {
        "label": "Special offer data populated for all properties",
        "done": true
      },
      {
        "label": "Replicate popup/banner display on property pages",
        "done": true,
        "note": "Defensive special-offer popup deployed on property pages with one-time auto-show per browser tab/session; top promo banner renders actual offer copy and opens the modal."
      }
    ]
  },
  {
    "title": "Property Count",
    "desc": "Reconciling contracted vs active properties.",
    "tasks": [
      {
        "label": "Bluffs at Catoosa — confirmed new construction, excluded from launch",
        "done": true
      },
      {
        "label": "Zeal at Quail — being prepared for launch on same timeline",
        "done": true
      },
      {
        "label": "Final reconciliation of 97 contracted vs 93 active",
        "done": true
      }
    ]
  }
] as const;

export const clientFeedback = [
  {
    "title": "Client Feedback: Tour Scheduling Links",
    "desc": "All 'Schedule a Tour' buttons/links across property pages should open tour options (in-person / self-guided) instead of navigating to the contact page.",
    "tasks": [
      { "label": "Property Home: hero 'Schedule a Tour' → schedule-a-tour page", "done": true },
      { "label": "Property Home: content stripe tour link → schedule-a-tour page", "done": true },
      { "label": "Property Home: floorplan section tour link → schedule-a-tour page", "done": true },
      { "label": "Property Home: bottom 'Take a Tour – Self-Guided Tour' bubble → Tour24", "done": true, "note": "Needs Tour24 URL integration" },
      { "label": "Floor Plans: per-floorplan 'Schedule a Tour' buttons → schedule-a-tour page", "done": true },
      { "label": "Amenities: 'Schedule a Tour' button → schedule-a-tour page", "done": true },
      { "label": "Pet Policy: CTA now links to schedule-a-tour instead of contact-us", "done": true },
      { "label": "Nav header: Schedule a Tour link → schedule-a-tour page", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Link Styling & Navigation",
    "desc": "Multiple hyperlinks need underline styling; several links point to wrong pages.",
    "tasks": [
      { "label": "Content links now underlined via CSS (.prop-al-blurb a, .prop-al-intro-text a, .prop-text-box p a)", "done": true },
      { "label": "Property Home: fix photo gallery link (not linked to photos page)", "done": true, "note": "Content override needed" },
      { "label": "Neighborhood: CTA now links to Contact Us instead of Floor Plans", "done": true },
      { "label": "Contact Us page: CTA now links to Schedule a Tour instead of Floor Plans", "done": true },
      { "label": "Pet Policy: CTA path fixed to /schedule-a-tour/", "done": true },
      { "label": "Self-guided link in floorplan paragraph verified working", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Page Spacing & Layout",
    "desc": "Several property subpages have excessive whitespace between content stripes. Reduce spacing or increase content to fill space.",
    "tasks": [
      { "label": "Floor Plans page: spacing reduced ~25%", "done": true },
      { "label": "Amenities page: spacing reduced ~25%", "done": true },
      { "label": "Neighborhood page: spacing reduced ~25%", "done": true },
      { "label": "Neighborhood: Entertainment & Recreation section — condense white space", "done": true, "note": "May need further adjustment" },
      { "label": "Pet Policy page: spacing reduced ~25%", "done": true },
      { "label": "Property Home: address under Visit Us now nowrap with mobile fallback", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Corporate Page Issues",
    "desc": "Various fixes needed on corporate-level pages (Home, About, Careers, Markets).",
    "tasks": [
      { "label": "Home: 'View Communities' button closer to images above", "done": true },
      { "label": "Home: Careers stripe — add space between last sentence and Careers link", "done": true },
      { "label": "Market page: 'Try These Popular Searches' links now apply filters in-page", "done": true },
      { "label": "Market page: location pin now correctly maps to property via name lookup", "done": true },
      { "label": "Apartments page: Tammaron Village — fix spacing between text and location pin", "done": true },
      { "label": "About Us: red overlay opacity reduced for better readability", "done": true },
      { "label": "About Us: 4 circle photos look odd — zoom out, change, or make larger", "done": true, "note": "Made photos larger, could use review. Also tokenized so we can easily change them." },
      { "label": "Careers: employee testimonial videos don't always load", "done": true },
      { "label": "Blog page: no content — determine if page is staying or going", "done": true, "note": "Removed for intiial launch." }
    ]
  },
  {
    "title": "Client Feedback: Amenity Enhancements",
    "desc": "Amenity sections need additional links, complete RentCafe data, and UX improvements.",
    "tasks": [
      { "label": "Community Amenities: Flex amenity → link to https://getflex.com/", "done": true },
      { "label": "Apartment Amenities: Cox amenity → link to https://www.cox.com/quickconnect", "done": true },
      { "label": "Amenities page: display all community amenities from RentCafe", "done": true },
      { "label": "Amenities page: display all apartment amenities from RentCafe", "done": true },
      { "label": "Remove 'Show More' button if all amenities fit without it", "done": true },
      { "label": "Floor Plans page: add Flex stripe (matching current site)", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Contact Form Issues",
    "desc": "Contact form delivery and option configuration.",
    "tasks": [
      { "label": "Corporate Contact Us form → deliver to casecares@caseusa.com", "status": "in-progress", "done": false, "note": "Tokenized Zapier webhook URL (corpcontact.webhook_url). POSTs JSON with formType 'corporate-contact'. Awaiting Zap setup." },
      { "label": "Vendor contact form → deliver to casecares@caseusa.com", "status": "in-progress", "done": false, "note": "Tokenized Zapier webhook URL (corpcontact.vendor_webhook_url). POSTs JSON with formType 'vendor-inquiry'. Awaiting Zap setup." },
      { "label": "Property Contact Us: remove 4+ bedroom option (max 3 or property-specific)", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Content — Corporate Pages",
    "desc": "Image replacements, market page corrections, and content updates on corporate pages. These are editor/override changes.",
    "tasks": [
      { "label": "Home: hide Catoosa market image/link (not ready yet)", "done": true },
      { "label": "Home: replace blurry Independence image", "done": true },
      { "label": "Home: replace blurry Lubbock image", "done": true },
      { "label": "Home: replace Ridgeland image with clubhouse pic", "done": true },
      { "label": "Home: replace Yukon image with better exterior/clubhouse", "done": true },
      { "label": "Apartments page: fix Bluffs at Catoosa image, description, and 'false' for phonenumber", "done": true },
      { "label": "Home: Broken Arrow showing Tulsa communities — verify if intentional", "done": true, "note": "Only Broken Arrow communities are shown now." },
      { "label": "Wichita: Crown Chase interior clubhouse photo is old", "done": false, "status": "blocked", note: "Many of the photos that we're pulling from various sources are either old or very low resolution. New photos would be great!" },
      { "label": "Wichita: Newport — remove playground photo (now a dog park)", "done": true },
      { "label": "About Us: replace top image with newer property exterior", "done": true }
    ]
  },
  {
    "title": "Client Feedback: Content — Market Pages Missing Properties",
    "desc": "Several market/city pages were missing properties from nearby suburbs. Resolved via theme-level market grouping in MARKET_GROUPS (propertyUtils.ts).",
    "tasks": [
      { "label": "Little Rock: add Lexington (North Little Rock address)", "done": true, "note": "Market grouping: ar/little-rock now includes north-little-rock" },
      { "label": "Kansas City: add Belton and Independence properties (Adirondack, 152 Northland)", "done": true, "note": "Market grouping: mo/kansas-city now includes belton, independence" },
      { "label": "OKC: add Cimarron Trails in Norman", "done": true, "note": "Market grouping: ok/oklahoma-city now includes norman, edmond, moore, yukon" },
      { "label": "Tulsa: add Owasso, Jenks, Broken Arrow properties", "done": true, "note": "Market grouping: ok/tulsa now includes broken-arrow, jenks, owasso" },
      { "label": "Waco: add Temple and Hewitt properties (Icon at Hewitt, Portico at Friar's Creek)", "done": true, "note": "Market grouping: tx/waco now includes temple, hewitt" },
      { "label": "Pryor market page: zoom out map", "done": true, "note": "computeBounds now enforces minimum ~3-mile viewport span" },
      { "label": "Stillwater market page: zoom out map", "done": true, "note": "computeBounds now enforces minimum ~3-mile viewport span" }
    ]
  },
  {
    "title": "Client Feedback: Content — Property Pages (24Hundred reference)",
    "desc": "Content-level fixes identified on 24Hundred as a reference property. These editor/override changes have now been handed off to the Case internal team following training.",
    "tasks": [
      { "label": "Internal team trained to handle remaining property page content edits", "done": true, "note": "Step-by-step handoff instructions.", "href": "https://docs.google.com/document/d/1sKgGi2n5ef7BsJG3EZ8PqOWjZLi0go9QgG6d9Rs7FBQ/edit?tab=t.0", "linkText": "Open editing instructions" },
      { "label": "Migrated POIs shared for ongoing content updates", "done": true, "note": "All POIs from the original site were merged with our crafted POIs, skipping closed businesses.", "href": "https://docs.google.com/spreadsheets/d/1__qKgIC9xQWoUgufR4hMowr79djnC1_Sqx06Gbrhsnw/edit?gid=1523332020#gid=1523332020", "linkText": "Open migrated POIs" },
      { "label": "Floor Plans: 'apartments' → 'apartment' in second sentence", "done": true },
      { "label": "Neighborhood: first and second content stripes have duplicate paragraph", "done": true },
      { "label": "Neighborhood: blurry business center pic — replace", "done": true },
      { "label": "Neighborhood: add schools (Elementary: Scissor Tail, Middle: Summit, High: Santa Fe)", "done": true },
      { "label": "Neighborhood: underline 'our Oklahoma City apartments' hyperlink", "done": true },
      { "label": "Neighborhood: blurry bathroom image in Shopping section — replace", "done": true },
      { "label": "Neighborhood: add more shops (Target, Costco, Dick's, Sam's Club)", "done": true },
      { "label": "Neighborhood: blurry entertainment section images", "done": true },
      { "label": "Pet Policy: blurry first image", "done": true },
      { "label": "Pet Policy: duplicate 'max of 2 pets allowed' text", "done": true },
      { "label": "Pet Policy: duplicate 'for any other questions…' text", "done": true },
      { "label": "Better photos throughout (planned for later?)", "done": true }
    ]
  }
] as const;
